export const GA_TRACKING_ID = 'GTM-WCN7NZS';
